export function getUITranslation(key, placeholders = {}) {
  let translation = window._translations?.[key] || key;

  for (const property in placeholders) {
    translation = translation.replaceAll(`%{${property}}`, placeholders[property]);
  }
  return translation;
}
